<div class="actions-bar" [class.disabled-actions]="!checkedPageEntries || checkedPageEntries.length === 0">
  <div>
    @for (action of availableCommands; track action) {
      <button mat-button (click)="executeCommand(action.command)">
        <span>
          @if (action.icon) {
            <i class="fas fa-{{ action.icon }}"></i>
          }
          <span>{{ action.buttonLabel }}</span>
        </span>
      </button>
    }
  </div>

  <div>
    <button data-id="refreshTickerBtn" class="always" mat-button (click)="refresh()">
      <span>
        <i class="fas fa-sync-alt" (click)="refresh()"></i>
        <span>Refresh</span>
      </span>
    </button>

    <button data-id="reloadTickerBtn" class="always" mat-button (click)="reload()">
      <span>
        <i class="fas fa-retweet" (click)="reload()"></i>
        <span>Reload</span>
      </span>
    </button>
  </div>
</div>
